/* PDP Gallery — contador 1/4 + peek da próxima foto */
(function () {
  'use strict';

  function init() {
    var galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function (gallery) {
      var slider = gallery.querySelector('slider-element');
      if (!slider) return;

      var items = slider.querySelectorAll('.product__media');
      var total = 0;
      items.forEach(function (item) {
        if (!item.hidden) total++;
      });
      if (total <= 1) return;

      // Cria contador
      var counter = document.createElement('div');
      counter.className = 'gallery-counter';
      counter.innerHTML = '<span>1</span> / ' + total;
      counter.setAttribute('aria-live', 'polite');

      // Posiciona no canto inferior direito da galeria
      var container = slider.parentElement;
      container.style.position = 'relative';
      container.appendChild(counter);

      // Esconde dots nativos
      var dots = gallery.querySelector('.product__thumbnails.with-dots');
      if (dots) dots.style.display = 'none';

      // Atualiza contador no scroll
      slider.addEventListener('scroll', debounce(function () {
        var page = Math.round(Math.abs(slider.scrollLeft) / slider.offsetWidth) + 1;
        if (page < 1) page = 1;
        if (page > total) page = total;
        counter.innerHTML = '<span>' + page + '</span> / ' + total;
      }, 80), { passive: true });
    });
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 200); });
  } else {
    setTimeout(init, 200);
  }
})();